import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { RolesPermissionGuard } from './core/permissions/roles-permissions.guard';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'settings',
      loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
      data: {
        breadcrumb: 'settings.title',
        permissionsKeys: [{ module: 'cms' }],
      },
    },
    {
      path: 'profile',
      loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
      data: {
        breadcrumb: 'profile.title',
      },
    },
    {
      path: 'home',
      loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
      canLoad: [RolesPermissionGuard],
      canActivate: [RolesPermissionGuard],
      data: {
        permissionsKeys: [{ module: 'dashboard' }],
      },
    },
    {
      path: '401',
      loadChildren: () => import('./401/unauthorized.module').then((m) => m.UnauthorizedModule),
      data: {
        breadcrumb: 'unauthorized.title',
      },
    },
    {
      path: 'clients',
      loadChildren: () => import('./clients/clients.module').then((m) => m.ClientsModule),
      data: {
        breadcrumb: 'clients.title',
      },
    },
    {
      path: 'device-settings',
      loadChildren: () => import('./device-settings/device-settings.module').then((m) => m.DeviceSettingsModule),
      data: {
        breadcrumb: 'device-settings.title',
        permissionsKeys: [{ module: 'devices' }, { module: 'commands' }],
      },
      canLoad: [RolesPermissionGuard],
      canActivate: [RolesPermissionGuard],
    },
    {
      path: 'accounts',
      loadChildren: () => import('./accounts/accounts.module').then((m) => m.AccountsModule),

      data: {
        breadcrumb: {
          label: 'accounts.title',
        },
        permissionsKeys: [{ module: 'users' }, { module: 'roles' }],
      },
      canLoad: [RolesPermissionGuard],
      canActivate: [RolesPermissionGuard],
    },
    {
      path: 'assets',
      loadChildren: () => import('./assets/assets.module').then((m) => m.AssetsModule),
      data: {
        breadcrumb: {
          label: 'assets.title',
          disable: true,
        },
      },
    },
       {
      path: 'locations',
      loadChildren: () => import('./locations/locations.module').then((m) => m.LocationsModule),
      data: {
        breadcrumb: {
          label: 'locations.title',
          disable: true,
        },
      },
    },
  ]),

  // Fallback when no prior route is matched
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      /**
       * stopped preloading all modules, defaults to lazy loading
       */
      // { preloadingStrategy: PreloadAllModules }
      { paramsInheritanceStrategy: 'always' },
    ),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
